import { post } from '@core/api/baseApi';
import { PostSendNotificationResponse, CustomErroHandlerResponse } from '@core/types';
import { StudyAssignedNotificationPayload } from '@core/types/Notification';

export const sendAssignedNotification = async (
  payload: StudyAssignedNotificationPayload,
): Promise<PostSendNotificationResponse | CustomErroHandlerResponse> =>
  await post(`/Studies/assigned-notification`, payload);
